<template>
  <div class="timer d-flex align-center">
    <img :src="clock_icon" class="mr-2"/><div class="timer-label">{{getTimeLeft()}}</div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'timerComponent',
  props: {
    date: {
      type: String,
      default: null,
      required: true,
    },
    on: {
      type: Boolean,
      default: true,
      required: false
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    style: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: ['finishCallback', 'resetCallback'],
  data() {
    return {
      timeoutHandle: null
    }
  },
  computed: {
  },
  setup() {

    const clock_icon = computed({
            get: () => { return require('../assets/icons/clock.svg'); }
        })
        return {
          clock_icon
        }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    refresh() {
      this.getTimeLeft();
    },
    getTimeLeft() {
      if(this.date && this.on) {
        let dateTo = new Date(this.date);
        let dateFrom = new Date();

        let timeSeconds = Math.floor((dateTo.getTime() - dateFrom.getTime())/1000);
        let timeMinutes = Math.floor(timeSeconds/60);
        let timeHours = Math.floor(timeMinutes/60);
        let timeDays = Math.floor(timeHours/24);

        let time = {
          timeSeconds,
          timeMinutes,
          timeHours,
          timeDays
        }
      
        if(time.timeSeconds > 25 * 60 * 60) {
          return this.getTimeDays(time);
        }

        if(time.timeSeconds > 60 * 60) {
          return this.getTimeHours(time);
        }

        if(time.timeSeconds > 0) {
          return this.getTimeMinutes(time);
        }

        if(time.timeSeconds <= 0) {
          return '---';
        }

        return '---';

      } else {
        return '---';
      }
    },
    getTimeDays(time) {
      return time.timeDays + 
        ((time.timeSeconds > (24 * 60 * 60 * 2)) ? ` ${this.$t('time.day.nom_plural')} ` : ` ${this.$t('time.day.nom')} `) + 
        this.getTimeHours({...time, timeHours: time.timeHours - time.timeDays * 24});
    },
    getTimeHours(time) {
      let word = '';
      if(time.timeHours == 0) {
        word = ` ${this.$t('time.hour.gen_plural')}`
      } else if(time.timeHours == 1) {
        word = ` ${this.$t('time.hour.nom')}`
      } else if (time.timeHours < 5) {
        word = ` ${this.$t('time.hour.nom_plural')}`
      } else if (time.timeHours < 21) {
        word = ` ${this.$t('time.hour.gen_plural')}`
      } else if (time.timeHours % 10 > 1 && time.timeHours % 10 < 5) {
        word = ` ${this.$t('time.hour.nom_plural')}`
      } else {
        word = ` ${this.$t('time.hour.gen_plural')}`
      }
      return time.timeHours + word;
    },
    getTimeMinutes(time) {
      let word = '';
      if(time.timeMinutes < 1 ) {
        return ` <1 ${this.$t('time.minute.nom')}`
      } else if(time.timeMinutes == 1) {
        word = ` ${this.$t('time.minute.nom')}`
      } else if (time.timeMinutes < 5) {
        word = ` ${this.$t('time.minute.nom_plural')}`
      } else if (time.timeMinutes < 21) {
        word = ` ${this.$t('time.minute.gen_plural')}`
      } else if (time.timeMinutes % 10 > 1 && time.timeMinutes % 10 < 5) {
        word = ` ${this.$t('time.minute.nom_plural')}`
      } else {
        word = ` ${this.$t('time.minute.gen_plural')}`
      }
      return time.timeMinutes + word;
    },
    getTimeSeconds(time) {
      let word = '';
      if(time.timeSeconds == 1) {
        word = ` ${this.$t('time.second.nom')}`
      } else if (time.timeSeconds < 5) {
        word = ` ${this.$t('time.second.nom_plural')}`
      } else if (time.timeSeconds < 21) {
        word = ` ${this.$t('time.second.gen_plural')}`
      } else if (time.timeSeconds % 10 > 1 && time.timeSeconds % 10 < 5) {
        word = ` ${this.$t('time.second.nom_plural')}`
      } else {
        word = ` ${this.$t('time.second.gen_plural')}`
      }
      return time.timeSeconds + word;
    }
  }
}
</script>

<style lang="scss" scoped>
  .timer {
      width: 100%;
    .timer-label {
      line-height: 16px;
      color: $ds-primary;
    }
  }
</style>